// extracted by mini-css-extract-plugin
export default {"title":"Card_title__GRqTL"};